import { Auth } from "./auth.js";
import { escapeHtml } from "./utils.js";
import { ensureMappingsLoaded } from "./orders_render.js";
import { loadStoredSalesData } from "./orders_data.js";

window._purchasePlans = [];
window._purchaseProducts = [];
window._activePurchaseTab = "pending";
window._purchaseSourceOrder = "";
window._purchaseCustomPrefill = null;
window._purchaseAttachments = [];

const PURCHASE_STATUS = {
  pending: { label: "未采购", color: "#64748b" },
  purchased: { label: "已采购", color: "#10b981" },
  inquiry: { label: "到货问询", color: "#f59e0b" },
  received: { label: "已到货", color: "#3b82f6" }
};

function normalizePurchaseStatus(status) {
  if (status === "purchased") return "purchased";
  if (status === "received" || status === "arrived") return "received";
  if (status === "inquiry") return "inquiry";
  return "pending";
}

function safeId(value) {
  return String(value || "").replace(/\\/g, "\\\\").replace(/'/g, "\\'");
}

function purchaseStatusBadge(status) {
  const meta = PURCHASE_STATUS[status] || PURCHASE_STATUS.pending;
  return '<span class="purchase-status-badge" style="background:' + meta.color + ';color:#fff;padding:2px 6px;border-radius:4px;font-size:0.7rem;margin-left:6px;">' + meta.label + '</span>';
}

function getProductImageHtml(model) {
  if (!model || model === "--" || model === "") {
    return '<span style="font-size:0.75rem;color:#94a3b8;">无图</span>';
  }
  const src = "/api/product-image/" + encodeURIComponent(model);
  return '<img src="' + src + '" alt="' + escapeHtml(model) + '" style="width:36px;height:36px;object-fit:contain;border-radius:4px;border:1px solid #e2e8f0;flex-shrink:0;" onerror="this.onerror=null;this.style.display=\'none\';this.nextSibling.style.display=\'inline\';" /><span style="display:none;font-size:0.75rem;color:#94a3b8;">无图</span>';
}

function updateProductDatalist() {
  const dl = document.getElementById("purchase-product-options");
  if (!dl) return;
  dl.innerHTML = window._purchaseProducts.map(function (p) {
    return '<option value="' + escapeHtml(p.model) + '">' + escapeHtml(p.productName || "") + '</option>';
  }).join("");
  updateColorDatalist();
}

function updateColorDatalist() {
  const dl = document.getElementById("purchase-color-options");
  if (!dl) return;
  const set = {};
  window._purchaseProducts.forEach(function (p) {
    (p.colorOptions || []).forEach(function (c) { if (c) set[c] = true; });
  });
  dl.innerHTML = Object.keys(set).map(function (c) {
    return '<option value="' + escapeHtml(c) + '"></option>';
  }).join("");
}

async function ensurePurchaseProducts() {
  if (window._purchaseProducts.length) return window._purchaseProducts;
  try {
    const data = await Auth.apiFetch("/api/products");
    window._purchaseProducts = data.products || [];
    updateProductDatalist();
  } catch (e) {
    console.error("加载产品失败:", e);
  }
  return window._purchaseProducts;
}

function findProduct(model) {
  const key = String(model || "").toLowerCase();
  return window._purchaseProducts.find(function (p) { return String(p.model || "").toLowerCase() === key; }) || null;
}

function updatePurchaseItemModel(itemEl) {
  const input = itemEl.querySelector(".purchase-item-model");
  const info = itemEl.querySelector(".purchase-model-info");
  if (!input || !info) return;
  updatePurchaseItemDescription(itemEl);
  const model = input.value.trim();
  const product = findProduct(model);
  if (!model) {
    info.innerHTML = '<span style="font-size:0.72rem;color:#94a3b8;">输入型号后自动带出产品信息</span>';
    return;
  }
  if (!product) {
    info.innerHTML = '<span style="font-size:0.72rem;color:#b45309;">\u81EA\u5B9A\u4E49\u578B\u53F7\uFF08\u4EC5\u672C\u5355\u4F7F\u7528\uFF09</span>';
    return;
  }
  const img = getProductImageHtml(product.model);
  const name = escapeHtml(product.productName || "");
  const sku = escapeHtml(product.model || "");
  const cost = product.purchaseCost ? '<span style="font-size:0.72rem;color:#64748b;">采购成本: ' + escapeHtml(product.purchaseCost) + '</span>' : "";
  info.innerHTML = '<div style="display:flex;align-items:center;gap:6px;margin-top:4px;">' + img + '<span style="font-size:0.75rem;color:#334155;">' + name + ' · SKU ' + sku + '</span>' + cost + '</div>';
}

function updatePurchaseItemDescription(itemEl) {
  if (!itemEl) return;
  const wrap = itemEl.querySelector(".purchase-item-description-wrap");
  if (!wrap) return;
  const current = itemEl.querySelector(".purchase-item-description");
  const currentValue = current ? current.value : "";
  const modelInput = itemEl.querySelector(".purchase-item-model");
  const model = modelInput ? modelInput.value.trim() : "";
  const product = findProduct(model);
  const importedName = itemEl.getAttribute("data-product-name") || "";
  const productName = model && (product || importedName) ? (importedName || (product && product.productName) || "") : "";
  const style = "width:100%;padding:7px 9px;border:1px solid #cbd5e1;border-radius:6px;font-size:0.78rem;";
  if (productName) {
    wrap.innerHTML = '<div class="purchase-item-description-text" style="padding:7px 9px;border:1px dashed #cbd5e1;border-radius:6px;font-size:0.78rem;color:#334155;background:#f8fafc;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escapeHtml(productName) + '</div>';
    return;
  }
  wrap.innerHTML = '<input class="purchase-item-description" type="text" placeholder="\u4EA7\u54C1\u63CF\u8FF0\uFF08\u989C\u8272\u3001\u89C4\u683C\u3001\u6750\u8D28\u7B49\uFF09" value="' + escapeHtml(currentValue || "") + '" style="' + style + '">';
}

function appendPurchaseVariant(itemEl, color, quantity) {
  const container = itemEl.querySelector(".purchase-variants");
  if (!container) return;
  const row = document.createElement("div");
  row.className = "purchase-variant-row";
  row.style.cssText = "display:grid;grid-template-columns:1fr 90px 30px;gap:6px;align-items:center;";
  row.innerHTML = '<input class="purchase-variant-color" list="purchase-color-options" placeholder="颜色" value="' + escapeHtml(color || "") + '" style="padding:6px 8px;border:1px solid #cbd5e1;border-radius:6px;font-size:0.78rem;">' +
    '<input class="purchase-variant-qty" type="number" min="1" step="1" placeholder="数量" value="' + escapeHtml(quantity || "") + '" style="padding:6px 8px;border:1px solid #cbd5e1;border-radius:6px;font-size:0.78rem;">' +
    '<button type="button" data-remove-variant style="border:none;background:#fef2f2;color:#dc2626;border-radius:6px;width:30px;height:30px;cursor:pointer;"><i class="fa-solid fa-xmark"></i></button>';
  container.appendChild(row);
}

function appendPurchaseItem(product) {
  const container = document.getElementById("purchase-order-items");
  if (!container) return;
  const item = document.createElement("div");
  item.className = "purchase-order-item";
  item.style.cssText = "border:1px solid #e2e8f0;border-radius:8px;padding:10px;background:#fff;";
  item.innerHTML = '<div style="display:flex;justify-content:space-between;align-items:flex-start;gap:8px;">' +
    '<div style="flex:1;min-width:0;">' +
      '<input class="purchase-item-model" list="purchase-product-options" autocomplete="off" placeholder="\u8F93\u5165\u578B\u53F7\u8054\u60F3\uFF0C\u4E5F\u53EF\u76F4\u63A5\u8F93\u5165\u81EA\u5B9A\u4E49\u578B\u53F7" value="' + escapeHtml(product && product.model ? product.model : "") + '" style="width:100%;padding:7px 9px;border:1px solid #cbd5e1;border-radius:6px;font-size:0.8rem;font-weight:bold;">' +
      '<div class="purchase-model-info" style="margin-top:4px;min-height:18px;"></div>' +
    '</div>' +
    '<button type="button" data-remove-item style="border:none;background:#fef2f2;color:#dc2626;border-radius:6px;width:30px;height:30px;cursor:pointer;flex-shrink:0;"><i class="fa-solid fa-trash"></i></button>' +
  '</div>' +
  '<div class="purchase-item-image" style="margin-top:8px;display:flex;align-items:flex-start;gap:8px;flex-wrap:wrap;">' +
    '<button type="button" class="purchase-item-image-button" style="border:1px solid #cbd5e1;background:#f8fafc;color:#334155;border-radius:6px;padding:5px 9px;cursor:pointer;font-size:0.72rem;"><i class="fa-solid fa-image"></i> \u4E0A\u4F20\u56FE\u7247</button>' +
    '<input type="file" accept="image/*" class="purchase-item-image-input" style="display:none;">' +
    '<div class="purchase-item-image-preview" style="display:flex;align-items:center;gap:6px;"></div>' +
    '<div class="purchase-item-description-wrap" style="flex:1;min-width:220px;"></div>' +
  '</div>' +
  '<div class="purchase-variants" style="margin-top:8px;display:flex;flex-direction:column;gap:6px;"></div>' +
  '<button type="button" data-add-color style="margin-top:8px;border:none;background:#f8fafc;color:#334155;border:1px dashed #cbd5e1;border-radius:6px;padding:5px 9px;cursor:pointer;font-size:0.72rem;"><i class="fa-solid fa-plus"></i> \u6DFB\u52A0\u989C\u8272/\u6570\u91CF</button>';

  if (product) {
    if (product.imageUrl) item.setAttribute("data-image-url", product.imageUrl);
    if (product.imageName) item.setAttribute("data-image-name", product.imageName);
    if (product.productName) item.setAttribute("data-product-name", product.productName);
  }

  const qty = product && product.quantity ? product.quantity : (product && product.variants ? "" : "1");
  appendPurchaseVariant(item, product && product.variants && product.variants[0] ? product.variants[0].color : "", product && product.variants && product.variants[0] ? product.variants[0].quantity : qty);

  const imageButton = item.querySelector(".purchase-item-image-button");
  const imageInput = item.querySelector(".purchase-item-image-input");
  if (imageButton && imageInput) {
    imageButton.addEventListener("click", function () { imageInput.click(); });
    imageInput.addEventListener("change", function () {
      if (imageInput.files && imageInput.files[0]) uploadPurchaseItemImage(imageInput.files[0], item);
    });
  }
  item.addEventListener("paste", function (e) {
    const files = e.clipboardData && e.clipboardData.files;
    if (!files || !files.length) return;
    const file = Array.prototype.slice.call(files).find(function (f) { return String(f.type || "").indexOf("image/") === 0; });
    if (file) { e.preventDefault(); uploadPurchaseItemImage(file, item); }
  });

  container.appendChild(item);
  renderPurchaseItemImage(item);
  updatePurchaseItemDescription(item);
  updatePurchaseItemModel(item);
  return item;
}

function renderPurchaseItemImage(itemEl) {
  if (!itemEl) return;
  const box = itemEl.querySelector(".purchase-item-image-preview");
  if (!box) return;
  const url = itemEl.getAttribute("data-image-url") || "";
  const name = itemEl.getAttribute("data-image-name") || "";
  if (!url) {
    box.innerHTML = '<span style="font-size:0.7rem;color:#94a3b8;">\u672A\u4E0A\u4F20\u56FE\u7247</span>';
    return;
  }
  box.innerHTML = '<img src="' + escapeHtml(url) + '" alt="' + escapeHtml(name) + '" style="width:44px;height:44px;object-fit:cover;border:1px solid #e2e8f0;border-radius:6px;">' +
    '<button type="button" class="purchase-item-image-remove" style="border:none;background:#fef2f2;color:#dc2626;border-radius:6px;padding:3px 6px;cursor:pointer;font-size:0.7rem;">\u5220\u9664</button>';
  const removeBtn = box.querySelector(".purchase-item-image-remove");
  if (removeBtn) removeBtn.addEventListener("click", function () { removePurchaseItemImage(itemEl); });
}

function removePurchaseItemImage(itemEl) {
  if (!itemEl) return;
  itemEl.removeAttribute("data-image-url");
  itemEl.removeAttribute("data-image-name");
  renderPurchaseItemImage(itemEl);
}

async function uploadPurchaseItemImage(file, itemEl) {
  if (!file || !itemEl) return;
  const button = itemEl.querySelector(".purchase-item-image-button");
  if (button) button.disabled = true;
  try {
    const fd = new FormData();
    fd.append("file", file, file.name || "image.png");
    const token = Auth.getToken();
    const res = await fetch("/api/purchase-attachments", {
      method: "POST",
      headers: token ? { "Authorization": "Bearer " + token } : {},
      body: fd
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.error || "upload failed");
    itemEl.setAttribute("data-image-url", data.url || "");
    itemEl.setAttribute("data-image-name", data.originalName || file.name || "");
    renderPurchaseItemImage(itemEl);
  } catch (e) {
    alert("\u56FE\u7247\u4E0A\u4F20\u5931\u8D25\uFF1A" + (e.message || "\u672A\u77E5\u9519\u8BEF"));
  } finally {
    if (button) button.disabled = false;
    const input = itemEl.querySelector(".purchase-item-image-input");
    if (input) input.value = "";
  }
}

function removePurchaseVariant(button) {
  const row = button.closest(".purchase-variant-row");
  const container = button.closest(".purchase-variants");
  if (!row || !container) return;
  if (container.querySelectorAll(".purchase-variant-row").length <= 1) {
    row.querySelector(".purchase-variant-color").value = "";
    row.querySelector(".purchase-variant-qty").value = "";
    return;
  }
  row.remove();
}

function removePurchaseItem(button) {
  const item = button.closest(".purchase-order-item");
  if (!item) return;
  if (document.querySelectorAll(".purchase-order-item").length <= 1) {
    item.remove();
    appendPurchaseItem();
    return;
  }
  item.remove();
}

function collectPurchaseOrderItems() {
  const nodes = Array.from(document.querySelectorAll(".purchase-order-item"));
  const items = [];
  for (const itemEl of nodes) {
    const modelInput = itemEl.querySelector(".purchase-item-model");
    const model = modelInput ? modelInput.value.trim() : "";
    const rows = Array.from(itemEl.querySelectorAll(".purchase-variant-row"));
    const variants = [];
    let invalid = false;
    rows.forEach(function (row) {
      const colorInput = row.querySelector(".purchase-variant-color");
      const qtyInput = row.querySelector(".purchase-variant-qty");
      const color = colorInput ? colorInput.value.trim() : "";
      const qtyRaw = qtyInput ? qtyInput.value.trim() : "";
      if (!color && !qtyRaw) return;
      const qty = parseInt(qtyRaw, 10);
      if (!qtyRaw || isNaN(qty) || qty < 1) {
        qtyInput.setCustomValidity("数量必须大于 0");
        qtyInput.reportValidity();
        invalid = true;
        return;
      }
      variants.push({ color: color, quantity: qty });
    });

    if (!model && !variants.length) continue;
    if (!model) {
      modelInput.setCustomValidity("请选择或新增型号");
      modelInput.reportValidity();
      return null;
    }
    const product = findProduct(model);
    if (invalid || !variants.length) {
      const firstQty = itemEl.querySelector(".purchase-variant-qty");
      if (firstQty) { firstQty.setCustomValidity("请至少填写一个颜色或数量"); firstQty.reportValidity(); }
      return null;
    }
    const totalQty = variants.reduce(function (sum, v) { return sum + (v.quantity || 0); }, 0);
    const imageUrl = itemEl.getAttribute("data-image-url") || "";
    const imageName = itemEl.getAttribute("data-image-name") || "";
    const descriptionInput = itemEl.querySelector(".purchase-item-description");
    const customDescription = descriptionInput ? descriptionInput.value.trim() : "";
    const importedName = itemEl.getAttribute("data-product-name") || "";
    if (product) {
      items.push({
        erpModel: product.model,
        sku: product.model,
        productName: importedName || product.productName || "",
        productLink: itemEl.getAttribute("data-product-link") || "",
        quantity: totalQty,
        variants: variants,
        imageUrl: imageUrl,
        imageName: imageName,
        isCustom: false
      });
    } else {
      items.push({
        erpModel: model,
        sku: model,
        productName: importedName || customDescription,
        productLink: itemEl.getAttribute("data-product-link") || "",
        quantity: totalQty,
        variants: variants,
        imageUrl: imageUrl,
        imageName: imageName,
        isCustom: true
      });
    }
  }

  return items.length ? items : null;
}

function normalizeDateInput(value) {
  if (!value) return "";
  const m = String(value).match(/^\d{4}-\d{2}-\d{2}/);
  return m ? m[0] : "";
}

function purchaseAttachmentUrl(a) {
  if (a && typeof a.url === 'string' && a.url) return a.url;
  return '#';
}

function renderPurchaseAttachments() {
  const list = document.getElementById("purchase-attachment-list");
  if (!list) return;
  const attachments = Array.isArray(window._purchaseAttachments) ? window._purchaseAttachments : [];
  if (!attachments.length) { list.innerHTML = ""; return; }
  list.innerHTML = attachments.map(function (a, idx) {
    const name = a.originalName || a.fileName || "附件";
    const url = purchaseAttachmentUrl(a);
    return '<div style="display:flex;align-items:center;gap:6px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:6px;padding:5px 8px;">' +
      '<i class="fa-solid fa-paperclip" style="color:#64748b;"></i>' +
      '<a href="' + escapeHtml(url) + '" target="_blank" style="flex:1;color:#0d9488;font-size:0.78rem;text-decoration:none;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escapeHtml(name) + '</a>' +
      '<button type="button" onclick="removePurchaseAttachment(' + idx + ')" style="border:none;background:#fef2f2;color:#dc2626;border-radius:6px;width:26px;height:26px;cursor:pointer;"><i class="fa-solid fa-xmark"></i></button></div>';
  }).join("");
}

function removePurchaseAttachment(index) {
  if (!Array.isArray(window._purchaseAttachments)) window._purchaseAttachments = [];
  window._purchaseAttachments.splice(index, 1);
  renderPurchaseAttachments();
}

async function uploadPurchaseAttachments(fileList) {
  const files = Array.from(fileList || []);
  if (!files.length) return;
  const token = Auth.getToken();
  const button = document.getElementById("purchase-attachment-button");
  if (button) button.disabled = true;
  try {
    for (const file of files) {
      const fd = new FormData();
      fd.append("file", file, file.name);
      const res = await fetch("/api/purchase-attachments", {
        method: "POST",
        headers: token ? { "Authorization": "Bearer " + token } : {},
        body: fd
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.error || "上传失败");
      window._purchaseAttachments.push({
        fileName: data.fileName,
        originalName: data.originalName || file.name,
        url: data.url,
        size: data.size,
        mime: data.mime
      });
    }
    renderPurchaseAttachments();
  } catch (e) {
    alert("附件上传失败：" + (e.message || "未知错误"));
  } finally {
    if (button) button.disabled = false;
    const input = document.getElementById("purchase-attachment-input");
    if (input) input.value = "";
  }
}

async function openPurchaseOrderDialog(orderId, prefill) {
  const dialog = document.getElementById("purchase-order-dialog");
  if (!dialog) return;
  await ensurePurchaseProducts();
  document.getElementById("purchase-order-no").value = "";
  document.getElementById("purchase-ship-date").value = "";
  document.getElementById("purchase-order-remark").value = "";
  const itemsEl = document.getElementById("purchase-order-items");
  itemsEl.innerHTML = "";
  window._purchaseSourceOrder = orderId || "";
  window._purchaseAttachments = [];
  renderPurchaseAttachments();

  if (prefill) {
    document.getElementById("purchase-order-no").value = prefill.orderNo || "";
    document.getElementById("purchase-ship-date").value = normalizeDateInput(prefill.shipDate || prefill.deliveryDate);
    document.getElementById("purchase-order-remark").value = prefill.notes || "";
    const products = Array.isArray(prefill.products) && prefill.products.length ? prefill.products : [];
    if (products.length) {
      products.forEach(function (p) {
        const model = p.model || p.erpModel || "";
        const quantity = parseInt(p.quantity || p.qty || "1", 10) || 1;
        let variants = Array.isArray(p.variants) && p.variants.length ? p.variants : [];
        if (!variants.length && p.color) variants = [{ color: p.color, quantity: quantity }];
        const productName = p.productName || p.name || p.title || p.description || "";
        const item = appendPurchaseItem({ model: model, quantity: quantity, variants: variants, productName: productName });
        if (item) {
          item.setAttribute("data-product-link", p.productLink || p.productLink || p.link || p.aliUrl || "");
          updatePurchaseItemModel(item);
        }
      });
    } else {
      appendPurchaseItem();
    }
  } else if (orderId && typeof allOrders !== "undefined" && allOrders) {
    const order = allOrders.find(function (o) { return String(o.id) === String(orderId); });
    if (order) {
      document.getElementById("purchase-order-no").value = order.id || "";
      document.getElementById("purchase-ship-date").value = normalizeDateInput(order.shipDate);
      const products = Array.isArray(order.products) && order.products.length ? order.products : [];
      if (products.length) {
        products.forEach(function (p) {
          const model = p.erpModel || p.model || "";
          const productName = p.productName || p.name || p.title || p.description || "";
          const item = appendPurchaseItem({ model: model, quantity: p.quantity || p.qty || "1", variants: [{ color: p.color || "", quantity: p.quantity || p.qty || "1" }], productName: productName });
          if (item) {
            item.setAttribute("data-product-link", p.link || p.aliUrl || "");
            const input = item.querySelector(".purchase-item-model");
            if (input) input.value = model;
            updatePurchaseItemModel(item);
          }
        });
      } else {
        appendPurchaseItem();
      }
    } else {
      appendPurchaseItem();
    }
  } else {
    appendPurchaseItem();
  }
  dialog.showModal();
  setTimeout(function () {
    const first = document.querySelector("#purchase-order-items .purchase-item-model");
    if (first) first.focus();
  }, 50);
}

function closePurchaseOrderDialog() {
  const dialog = document.getElementById("purchase-order-dialog");
  if (dialog) dialog.close();
}

function openPurchaseOrderFromOrder(orderId) {
  window._pendingPurchaseOrderId = orderId || "";
  const nav = document.querySelector('.nav-item[data-target="view-purchase-plan"] a');
  if (nav) nav.click();
  else openPurchaseOrderDialog(orderId);
}

function openPurchaseOrderFromCustom(prefill) {
  window._purchaseCustomPrefill = prefill || null;
  const nav = document.querySelector('.nav-item[data-target="view-purchase-plan"] a');
  if (nav) nav.click();
  else openPurchaseOrderDialog(null, prefill);
}

function updatePurchaseTabCounts() {
  const counts = { pending: 0, purchased: 0, inquiry: 0, received: 0 };
  window._purchasePlans.forEach(function (p) { counts[normalizePurchaseStatus(p.status)]++; });
  Object.keys(counts).forEach(function (key) {
    const el = document.getElementById("purchase-count-" + key);
    if (el) el.textContent = counts[key];
  });
}

async function savePurchaseAnnotation(planId) {
  const textarea = document.getElementById("annotation-" + safeId(planId));
  if (!textarea) return;
  const annotation = textarea.value.trim();
  try {
    let data;
    try {
      data = await Auth.apiFetch("/api/purchase-plans/" + encodeURIComponent(planId) + "/annotation", {
        method: "PUT",
        body: JSON.stringify({ annotation: annotation })
      });
    } catch (e) {
      if (!/Unexpected token|is not valid JSON/i.test(e.message || "")) throw e;
      data = await Auth.apiFetch("/api/purchase-plans", {
        method: "POST",
        body: JSON.stringify({ id: planId, annotation: annotation })
      });
    }
    const plan = (window._purchasePlans || []).find(function (p) { return p.id === planId; });
    if (plan) {
      plan.annotation = annotation;
      if (data.plan && data.plan.updatedAt) plan.updatedAt = data.plan.updatedAt;
    }
    renderPurchaseLedger();
  } catch (e) {
    alert("批注保存失败：" + (e.message || "未知错误"));
  }
}

function isAnnotationUnread(plan) {
  if (!plan || !plan.annotation) return false;
  if (!plan.annotationAt) return false;
  if (!plan.annotationReadAt) return true;
  return new Date(plan.annotationReadAt).getTime() < new Date(plan.annotationAt).getTime();
}
function updatePurchaseUnreadBadge() {
  const badge = document.getElementById("purchase-unread-inquiry");
  if (!badge) return;
  const n = (window._purchasePlans || []).filter(isAnnotationUnread).length;
  badge.textContent = String(n);
  badge.style.display = n > 0 ? "inline-block" : "none";
}
async function markAllAnnotationRead() {
  const unread = (window._purchasePlans || []).filter(isAnnotationUnread);
  if (!unread.length) return;
  try {
    await Auth.apiFetch("/api/purchase-plans/annotation-read-all", { method: "PUT" });
    const now = new Date().toISOString();
    unread.forEach(function (p) { p.annotationReadAt = now; });
    updatePurchaseUnreadBadge();
    renderPurchaseLedger();
  } catch (e) { console.error("批量标记已读失败:", e); }
}
async function markAnnotationRead(planId) {
  const p = (window._purchasePlans || []).find(function (x) { return x.id === planId; });
  if (p && !isAnnotationUnread(p)) return;
  try {
    await Auth.apiFetch("/api/purchase-plans/" + encodeURIComponent(planId) + "/annotation-read", { method: "PUT" });
    if (p) p.annotationReadAt = new Date().toISOString();
    renderPurchaseLedger();
    updatePurchaseUnreadBadge();
  } catch (e) { console.error("标记已读失败:", e); }
}

function buildPurchaseCard(plan) {
  const status = normalizePurchaseStatus(plan.status);
  const card = document.createElement("div");
  card.className = "purchase-plan-card";
  card.id = plan.id;
  card.style.cssText = "background:#fafdfb;border:1px solid var(--border-color);border-left:4px solid #0d9488;border-radius:8px;padding:12px;box-shadow:0 1px 3px rgba(0,0,0,0.05);";
  const orderNo = plan.orderNo || plan.orderId || plan.id || "--";
  // 单号是国际站订单号（纯数字）时，即使这张单是“定制单”等入口建的、没存 orderLink，也自动让它可点
  let orderLink = plan.orderLink || "";
  if (!orderLink) {
    const noRaw = String(plan.orderNo || "").trim();
    if (/^\d{12,}$/.test(noRaw)) orderLink = "https://biz.alibaba.com/ta/detail.htm?orderId=" + noRaw;
  }
  const orderNoHtml = orderLink ? '<a href="' + escapeHtml(orderLink) + '" target="_blank" rel="noopener" style="font-weight:bold;color:#0d9488;font-size:0.9rem;text-decoration:none;border-bottom:1px dashed #0d9488;" title="打开国际站订单"><i class="fa-solid fa-cart-shopping"></i> ' + escapeHtml(orderNo) + ' <i class="fa-solid fa-arrow-up-right-from-square" style="font-size:0.7rem;"></i></a>' : '<span style="font-weight:bold;color:#0d9488;font-size:0.9rem;"><i class="fa-solid fa-cart-shopping"></i> ' + escapeHtml(orderNo) + '</span>';
  const salesperson = plan.salesperson || plan.owner || "--";
  const shipDate = plan.shipDate && plan.shipDate !== "--" ? plan.shipDate : "";
  const badge = purchaseStatusBadge(status);
  const annotation = plan.annotation || "";
  const isBoss = Auth.getRole() === "boss";
  let annotationHtml = "";
  if (isBoss) {
    annotationHtml = '<div style="margin-top:8px;padding:8px;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:6px;">' +
      '<div style="display:flex;gap:8px;align-items:flex-start;">' +
      '<textarea id="annotation-' + safeId(plan.id) + '" class="purchase-annotation-input" placeholder="\u6279\u6CE8\uFF08\u4EC5 Samson \u53EF\u586B\u5199\uFF09" style="flex:1;min-height:44px;padding:6px 8px;border:1px solid #cbd5e1;border-radius:6px;font-size:0.78rem;resize:vertical;">' + escapeHtml(annotation) + '</textarea>' +
      '<button type="button" onclick="savePurchaseAnnotation(\'' + safeId(plan.id) + '\')" style="flex-shrink:0;background:#0d9488;color:#fff;border:none;border-radius:6px;padding:7px 12px;cursor:pointer;font-size:0.78rem;font-weight:bold;"><i class="fa-solid fa-check"></i> 保存</button>' +
      '</div></div>';
  } else if (annotation) {
    if (isAnnotationUnread(plan)) {
      annotationHtml = '<div onclick="markAnnotationRead(\'' + safeId(plan.id) + '\')" style="margin-top:8px;padding:6px 8px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;font-size:0.75rem;color:#991b1b;cursor:pointer;">' +
        '<span style="background:#ef4444;color:#fff;padding:1px 6px;border-radius:999px;font-size:0.68rem;font-weight:bold;margin-right:4px;">新批注</span>' +
        '<strong>批注：</strong>' + escapeHtml(annotation) +
        '<div style="margin-top:4px;font-size:0.68rem;color:#b91c1c;">点击此处标记为已读</div></div>';
    } else {
      annotationHtml = '<div style="margin-top:8px;padding:6px 8px;background:#f8fafc;border:1px dashed #cbd5e1;border-radius:6px;font-size:0.75rem;color:#334155;"><strong>批注：</strong>' + escapeHtml(annotation) + '</div>';
    }
  }

  let productsHtml = "";
  const products = plan.products || [];
  if (products.length) {
    productsHtml = products.map(function (p) {
      const model = p.erpModel || p.model || p.sku || "--";
      const name = p.productName || p.name || p.title || "";
      const productLink = p.productLink || p.link || "";
      const nameText = name || productLink || "";
      const nameHtml = productLink ? '<a href="' + escapeHtml(productLink) + '" target="_blank" rel="noopener" style="color:#334155;font-size:0.78rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;text-decoration:underline;" title="' + escapeHtml(productLink) + '">' + escapeHtml(nameText) + '</a>' : '<span style="color:#334155;font-size:0.78rem;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">' + escapeHtml(name) + '</span>';
      const img = p.imageUrl
        ? '<a href="' + escapeHtml(p.imageUrl) + '" target="_blank" rel="noopener" style="flex-shrink:0;"><img src="' + escapeHtml(p.imageUrl) + '" alt="' + escapeHtml(model) + '" style="width:40px;height:40px;object-fit:cover;border-radius:4px;border:1px solid #e2e8f0;"></a>'
        : getProductImageHtml(model);
      const customTag = p.isCustom ? '<span style="font-size:0.68rem;color:#b45309;background:#fef3c7;border:1px solid #fcd34d;padding:1px 5px;border-radius:3px;flex-shrink:0;">\u81EA\u5B9A\u4E49</span>' : '';
      let detail = "";
      if (Array.isArray(p.variants) && p.variants.length) {
        detail = p.variants.map(function (v) {
          const color = v.color || "未填颜色";
          return '<span style="background:#f1f5f9;border:1px solid #e2e8f0;border-radius:4px;padding:2px 6px;font-size:0.72rem;color:#334155;">' + escapeHtml(color) + ' x' + escapeHtml(v.quantity) + '</span>';
        }).join(" ");
      } else {
        const qty = p.quantity || p.qty || "1";
        detail = '<span class="product-qty" style="font-weight:bold;color:#0f172a;font-size:0.78rem;">x' + escapeHtml(qty) + '</span>';
      }
      return '<div class="product-item" style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px dashed #f1f5f9;padding:5px 0;gap:8px;">' +
        '<div style="display:flex;align-items:center;gap:6px;min-width:0;flex:1;">' + img +
        '<span style="font-weight:700;color:#0d9488;font-size:0.75rem;background:#ecfdf5;padding:1px 5px;border-radius:3px;border:1px solid #a7f3d0;">' + escapeHtml(model) + '</span>' +
        customTag +
        nameHtml + '</div>' +
        '<div style="display:flex;align-items:center;gap:5px;flex-shrink:0;">' + detail + '</div></div>';
    }).join("");
  } else {
    productsHtml = '<div style="color:#94a3b8;font-style:italic;font-size:0.8rem;">暂无商品明细</div>';
  }

  const notesHtml = plan.notes ? '<div style="margin-top:8px;padding:6px 8px;background:#fffbeb;border:1px solid #fcd34d;border-radius:4px;font-size:0.75rem;color:#92400e;"><i class="fa-solid fa-note-sticky" style="margin-right:4px;"></i><strong>备注：</strong>' + escapeHtml(plan.notes) + '</div>' : "";
  let attachmentsHtml = "";
  const attachments = Array.isArray(plan.attachments) ? plan.attachments : [];
  if (attachments.length) {
    attachmentsHtml = '<div style="margin-top:8px;display:flex;flex-wrap:wrap;gap:6px;">' + attachments.map(function (a) {
      const name = a.originalName || a.fileName || "附件";
      const url = purchaseAttachmentUrl(a);
      return '<a href="' + escapeHtml(url) + '" target="_blank" style="display:inline-flex;align-items:center;gap:4px;background:#f8fafc;border:1px solid #e2e8f0;border-radius:5px;padding:3px 7px;font-size:0.72rem;color:#0d9488;text-decoration:none;"><i class="fa-solid fa-paperclip"></i>' + escapeHtml(name) + '</a>';
    }).join("") + '</div>';
  }

  const sid = safeId(plan.id);
  let actions = "";
  if (status === "pending") {
    actions += '<button class="btn-small" style="background:#10b981;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'purchased\')"><i class="fa-solid fa-check"></i> 标记已采购</button>';
  }
  if (status === "purchased") {
    actions += '<button class="btn-small" style="background:#64748b;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'pending\')"><i class="fa-solid fa-arrow-left"></i> 退回未采购</button>';
    actions += '<button class="btn-small" style="background:#f59e0b;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'inquiry\')"><i class="fa-solid fa-circle-question"></i> 到货问询</button>';
    actions += '<button class="btn-small" style="background:#3b82f6;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'received\')"><i class="fa-solid fa-box"></i> 标记已到货</button>';
  }
  if (status === "inquiry") {
    actions += '<button class="btn-small" style="background:#64748b;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'purchased\')"><i class="fa-solid fa-arrow-left"></i> 退回已采购</button>';
    actions += '<button class="btn-small" style="background:#3b82f6;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'received\')"><i class="fa-solid fa-box"></i> 标记已到货</button>';
  }
  if (status === "received") {
    actions += '<button class="btn-small" style="background:#f59e0b;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="changePurchaseStatus(\'' + sid + '\', \'inquiry\')"><i class="fa-solid fa-circle-question"></i> 到货问询</button>';
  }
  actions += '<button class="btn-small" style="background:#ef4444;color:#fff;border:none;padding:4px 8px;border-radius:4px;cursor:pointer;font-size:0.75rem;font-weight:bold;" onclick="removePurchasePlan(\'' + sid + '\')"><i class="fa-solid fa-trash"></i> 删除</button>';

  card.innerHTML = '<div style="display:flex;flex-direction:column;gap:6px;">' +
    '<div style="display:flex;justify-content:space-between;align-items:center;border-bottom:1px dashed #e2e8f0;padding-bottom:6px;"><div style="display:flex;align-items:center;gap:6px;min-width:0;">' + orderNoHtml + badge + '</div><span style="font-weight:800;color:#be123c;font-size:1rem;">' + escapeHtml(plan.amount || "--") + '</span></div>' +
    '<div style="display:flex;align-items:center;flex-wrap:wrap;gap:6px;font-size:0.8rem;color:#64748b;"><span style="background:#e0f2fe;color:#0369a1;padding:2px 6px;border-radius:4px;"><i class="fa-solid fa-user-tie"></i> ' + escapeHtml(salesperson) + '</span>' + (shipDate ? '<span style="background:#f8fafc;padding:2px 6px;border-radius:4px;border:1px solid #e2e8f0;">交期 ' + escapeHtml(shipDate) + '</span>' : "") + '</div>' +
    '<div>' + productsHtml + '</div>' + notesHtml + attachmentsHtml +
    '<div style="display:flex;justify-content:flex-end;gap:6px;padding-top:6px;border-top:1px dashed #e2e8f0;margin-top:4px;flex-wrap:wrap;">' + actions + '</div>' + annotationHtml + '</div>';
  return card;
}

function renderPurchaseLedger() {
  const searchInput = document.getElementById("purchase-search-input");
  const search = searchInput ? searchInput.value.toLowerCase() : "";
  const active = window._activePurchaseTab;
  const listEl = document.getElementById("purchase-tab-" + active);
  if (!listEl) return;
  const list = window._purchasePlans.filter(function (p) {
    if (normalizePurchaseStatus(p.status) !== active) return false;
    if (!search) return true;
    const hay = [p.orderNo, p.orderId, p.id, p.notes, p.salesperson, (p.products || []).map(function (x) { return [x.erpModel, x.model, x.sku, x.productName, x.name, x.title, (x.variants || []).map(function (v) { return v.color; }).join(" ")].join(" "); }).join(" ")].join(" ").toLowerCase();
    return hay.indexOf(search) !== -1;
  });
  list.sort(function (a, b) {
    const ta = a.createdAt || a.updatedAt || "";
    const tb = b.createdAt || b.updatedAt || "";
    if (ta || tb) {
      const cmp = String(tb).localeCompare(String(ta));
      if (cmp !== 0) return cmp;
    }
    const an = String(a.id || "").match(/\d+/g);
    const bn = String(b.id || "").match(/\d+/g);
    const av = an ? parseInt(an.join(""), 10) : 0;
    const bv = bn ? parseInt(bn.join(""), 10) : 0;
    return bv - av;
  });

  if (!list.length) {
    listEl.innerHTML = '<div style="text-align:center;color:var(--text-muted);padding:60px;"><i class="fa-solid fa-inbox" style="font-size:2rem;display:block;margin-bottom:12px;"></i>暂无采购单</div>';
  } else {
    listEl.innerHTML = "";
    list.forEach(function (plan) { listEl.appendChild(buildPurchaseCard(plan)); });
  }
  updatePurchaseTabCounts();
  updatePurchaseUnreadBadge();
}

function switchPurchaseTab(status) {
  window._activePurchaseTab = status;
  document.querySelectorAll(".purchase-tab").forEach(function (btn) {
    const active = btn.getAttribute("data-purchase-tab") === status;
    btn.classList.toggle("is-active", active);
    btn.style.background = active ? "#0d9488" : "#f1f5f9";
    btn.style.color = active ? "#fff" : "#334155";
    btn.style.borderColor = active ? "#0d9488" : "#cbd5e1";
  });
  document.querySelectorAll(".purchase-tab-list").forEach(function (el) {
    const key = el.id.replace("purchase-tab-", "");
    el.style.display = key === status ? "grid" : "none";
  });
  if (status === "inquiry") { markAllAnnotationRead(); }
  renderPurchaseLedger();
}

async function loadPurchasePlans() {
  if (!document.getElementById("purchase-tab-pending")) return;
  try {
    const data = await Auth.apiFetch("/api/purchase-plans");
    window._purchasePlans = data.plans || [];
    window._activePurchaseTab = "pending";
    switchPurchaseTab(window._activePurchaseTab);
    if (window._purchaseCustomPrefill) {
      const customPrefill = window._purchaseCustomPrefill;
      window._purchaseCustomPrefill = null;
      await openPurchaseOrderDialog(null, customPrefill);
    }
    if (window._pendingPurchaseOrderId) {
      const pendingId = window._pendingPurchaseOrderId;
      window._pendingPurchaseOrderId = "";
      await openPurchaseOrderDialog(pendingId);
    }
  } catch (e) {
    console.error("加载采购单失败:", e);
  }
}

function changePurchaseStatus(planId, status) {
  Auth.apiFetch("/api/purchase-plans/" + encodeURIComponent(planId) + "/status", {
    method: "PUT",
    body: JSON.stringify({ status: status })
  })
    .then(function (res) {
      // 本地同步最新状态：卡片立即从当前 Tab 移走（不切换视图，留在当前 Tab）
      const updated = (res && res.plan) || null;
      (window._purchasePlans || []).forEach(function (p) {
        if (p.id === planId) Object.assign(p, updated || { status: status });
      });
      renderPurchaseLedger();
      if (typeof loadStoredSalesData === "function") setTimeout(loadStoredSalesData, 300);
    })
    .catch(function (e) { console.error("更新状态失败:", e); });
}

function removePurchasePlan(planId) {
  if (!confirm("确定删除此采购单吗？")) return;
  Auth.apiFetch("/api/purchase-plans/" + encodeURIComponent(planId), { method: "DELETE" })
    .then(function () {
      window._purchasePlans = window._purchasePlans.filter(function (p) { return p.id !== planId; });
      renderPurchaseLedger();
      if (typeof loadStoredSalesData === "function") setTimeout(loadStoredSalesData, 300);
    })
    .catch(function (e) { alert("删除失败：" + (e.message || "未知错误")); });
}

function syncPurchaseBadgesToOrders() {
  Auth.apiFetch("/api/purchase-plans").then(function (data) {
    const plans = data.plans || [];
    plans.forEach(function (plan) {
      const status = normalizePurchaseStatus(plan.status);
      if (status === "pending" || !plan.orderId) return;
      const orderCard = document.getElementById("self-" + plan.orderId) || document.getElementById("todo-" + plan.orderId);
      if (!orderCard) return;
      const existingBadge = orderCard.querySelector(".purchase-status-badge");
      if (existingBadge) existingBadge.remove();
      const salesSpan = orderCard.querySelector('span[style*="#e0f2fe"]') || orderCard.querySelector("span i.fa-user-tie");
      const target = salesSpan ? (salesSpan.closest("span") || salesSpan) : null;
      if (!target) return;
      const badge = document.createElement("span");
      badge.className = "purchase-status-badge";
      const meta = PURCHASE_STATUS[status];
      badge.style.cssText = "background:" + meta.color + ";color:#fff;padding:2px 8px;border-radius:10px;font-size:0.7rem;margin-left:6px;display:inline-block;";
      badge.textContent = meta.label;
      target.parentElement.insertBefore(badge, target.nextSibling);
    });
  }).catch(function (e) { console.error("同步采购徽章失败:", e); });
}

async function savePurchaseOrder(event) {
  event.preventDefault();
  const orderNo = document.getElementById("purchase-order-no").value.trim();
  const shipDate = document.getElementById("purchase-ship-date").value;
  const remark = document.getElementById("purchase-order-remark").value.trim();
  const items = collectPurchaseOrderItems();
  if (!items) return;

  let sourceOrder = null;
  if (window._purchaseSourceOrder && typeof allOrders !== "undefined" && allOrders) {
    sourceOrder = allOrders.find(function (o) { return String(o.id) === String(window._purchaseSourceOrder); }) || null;
  }
  // 兜底：没带订单上下文时（如“定制单 → 下采购单”入口），按“单号”反查订单，
  // 这样订单链接/金额/买家信息就和“订单总览 → 去采购”保持一致
  if (!sourceOrder && orderNo && typeof allOrders !== "undefined" && Array.isArray(allOrders)) {
    sourceOrder = allOrders.find(function (o) { return String(o.id) === String(orderNo).trim(); }) || null;
  }
  const user = Auth.getUser();
  const plan = {
    id: "pp-" + Date.now(),
    orderId: sourceOrder ? sourceOrder.id : "",
    orderNo: orderNo,
    orderLink: sourceOrder ? (sourceOrder.orderUrl || "https://biz.alibaba.com/ta/detail.htm?orderId=" + sourceOrder.id)
                           : (/^\d{12,}$/.test(String(orderNo || "").trim()) ? "https://biz.alibaba.com/ta/detail.htm?orderId=" + String(orderNo).trim() : ""),
    salesperson: user ? (user.displayName || user.username) : (sourceOrder ? sourceOrder.salesperson : "--"),
    amount: sourceOrder ? (sourceOrder.amount || "--") : "--",
    daysLeft: sourceOrder ? (sourceOrder.daysLeft !== undefined && sourceOrder.daysLeft !== null ? sourceOrder.daysLeft : null) : null,
    shipDate: shipDate || (sourceOrder ? (sourceOrder.shipDate || "") : ""),
    country: sourceOrder ? (sourceOrder.buyerCountry || sourceOrder.shippingCountry || "--") : "--",
    buyerName: sourceOrder ? (sourceOrder.buyerName || "") : "",
    owner: user ? user.username : "",
    products: items,
    notes: remark,
    attachments: Array.isArray(window._purchaseAttachments) ? window._purchaseAttachments.slice() : [],
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    status: "pending"
  };

  try {
    await Auth.apiFetch("/api/purchase-plans", { method: "POST", body: JSON.stringify(plan) });
    closePurchaseOrderDialog();
    await loadPurchasePlans();
  } catch (e) {
    alert("保存失败：" + (e.message || "未知错误"));
  }
}

document.addEventListener("click", function (event) {
  const dialog = document.getElementById("purchase-order-dialog");
  if (dialog && event.target === dialog) {
    const rect = dialog.getBoundingClientRect();
    const inDialog = event.clientX >= rect.left && event.clientX <= rect.right && event.clientY >= rect.top && event.clientY <= rect.bottom;
    if (!inDialog) closePurchaseOrderDialog();
  }
});

document.addEventListener("input", function (event) {
  if (event.target.classList.contains("purchase-item-model")) {
    updatePurchaseItemModel(event.target.closest(".purchase-order-item"));
  }
  if (event.target.classList.contains("purchase-variant-color")) {
    updateColorDatalist();
  }
});

document.addEventListener("click", function (event) {
  const addItem = event.target.closest("#purchase-add-item");
  if (addItem) { appendPurchaseItem(); return; }
  const addColor = event.target.closest("[data-add-color]");
  if (addColor) { appendPurchaseVariant(addColor.closest(".purchase-order-item"), "", ""); return; }
  const removeVariant = event.target.closest("[data-remove-variant]");
  if (removeVariant) { removePurchaseVariant(removeVariant); return; }
  const removeItem = event.target.closest("[data-remove-item]");
  if (removeItem) { removePurchaseItem(removeItem); return; }
});

document.addEventListener("submit", function (event) { if (event.target && event.target.id === "purchase-order-form") savePurchaseOrder(event); });

window.openPurchaseOrderDialog = openPurchaseOrderDialog;
window.closePurchaseOrderDialog = closePurchaseOrderDialog;
window.switchPurchaseTab = switchPurchaseTab;
window.renderPurchaseLedger = renderPurchaseLedger;
window.changePurchaseStatus = changePurchaseStatus;
window.removePurchasePlan = removePurchasePlan;
window.openPurchaseOrderFromOrder = openPurchaseOrderFromOrder;
window.addToPurchasePlan = openPurchaseOrderFromOrder;
window.openPurchaseOrderFromCustom = openPurchaseOrderFromCustom;
window.uploadPurchaseAttachments = uploadPurchaseAttachments;
window.removePurchaseAttachment = removePurchaseAttachment;
window.savePurchaseAnnotation = savePurchaseAnnotation;
window.markAnnotationRead = markAnnotationRead;
window.markAllAnnotationRead = markAllAnnotationRead;

export { loadPurchasePlans, syncPurchaseBadgesToOrders };
